import GenericError from './GenericError';

export function createError(error: unknown): Error {
  return error instanceof Error ? error : new GenericError('An error occured', error);
}
